export default {"src":"/_next/static/media/Youtube.1764cecb.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};